(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  // Automatiskt generera Table of Contents från H2 rubriker
  function initTableOfContents() {
    const articleBody = document.querySelector('.article-body');
    const tocList = document.getElementById('toc-list');
    
    if (!articleBody || !tocList) {
      console.log('Article body or TOC list not found');
      return;
    }
    
    // Hitta alla H2 rubriker i article-body
    const headings = articleBody.querySelectorAll('h2');
    
    console.log('Found headings:', headings.length);
    
    if (headings.length === 0) {
      // Om inga H2 finns, dölj Table of Contents
      const sidebarSection = document.querySelector('.sidebar-toc');
      if (sidebarSection) {
        sidebarSection.style.display = 'none';
        console.log('No headings found, hiding TOC');
      }
      return;
    }
    
    // Rensa befintligt innehåll
    tocList.innerHTML = '';
    
    headings.forEach((heading, index) => {
      // Skapa unikt ID för varje rubrik
      const id = 'heading-' + index;
      heading.id = id;
      
      // Skapa TOC länk
      const link = document.createElement('a');
      link.href = '#' + id;
      link.className = 'toc-item';
      link.textContent = heading.textContent;
      
      // Smooth scroll
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetPosition = heading.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
        
        // Uppdatera aktiv länk
        document.querySelectorAll('.toc-item').forEach(item => item.classList.remove('active'));
        link.classList.add('active');
      });
      
      tocList.appendChild(link);
    });
    
    console.log('TOC initialized with', headings.length, 'items');
    
    // Highlight aktiv sektion vid scroll
    let ticking = false;
    
    function updateActiveLink() {
      const scrollPos = window.scrollY + 150;
      
      headings.forEach((heading, index) => {
        const headingTop = heading.offsetTop;
        const nextHeading = headings[index + 1];
        const headingBottom = nextHeading ? nextHeading.offsetTop : document.body.scrollHeight;
        
        if (scrollPos >= headingTop && scrollPos < headingBottom) {
          document.querySelectorAll('.toc-item').forEach(item => item.classList.remove('active'));
          const activeLink = tocList.querySelector(`a[href="#${heading.id}"]`);
          if (activeLink) activeLink.classList.add('active');
        }
      });
      
      ticking = false;
    }
    
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateActiveLink);
        ticking = true;
      }
    });
    
    // Initiera första aktiva länken
    updateActiveLink();
  }
  
  // Försök initiera flera gånger för att säkerställa att DOM är redo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTableOfContents);
  } else {
    initTableOfContents();
  }
  
  // Backup: försök igen efter en kort delay
  setTimeout(initTableOfContents, 500);
  setTimeout(initTableOfContents, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
